import { useState } from 'react';
import { Paper } from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import { QuickSearchToolbar } from '../rack/dashboard/RacksTable';

const paginationModel = { page: 0, pageSize: 5 };

CustomTable.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array
};

export default function CustomTable({ data, columns }) {
  const defaultPageSize = 5;
  const [pageSize, setPageSize] = useState(defaultPageSize);

  return (
    <Paper sx={{ minHeight: 400, width: '100%' }}>
      <DataGrid
        rows={data}
        columns={columns}
        getRowId={(row) => row.name}
        autoHeight
        initialState={{ pagination: { paginationModel } }}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[5, 10, 20]}
        pagination
        filterPanelDeleteIcon
        components={{ Toolbar: QuickSearchToolbar }}
        sx={{ border: 0 }}
      />
    </Paper>
  );
}
